import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} {...props}>
		<path
			fill='#ee2b7b'
			d='M16.117 7.789a4.249 4.249 0 0 0-.771-2.449 4.944 4.944 0 0 0-.445-.542 4.591 4.591 0 0 0-.532-.458 4.24 4.24 0 0 0-1.124-.6 4.3 4.3 0 0 0-4.69 1.276 4.738 4.738 0 0 0-.418.58 4.432 4.432 0 0 0-.306.64 4.278 4.278 0 0 0 2.16 5.429 4.01 4.01 0 0 0 1.409.391 4.269 4.269 0 0 0 4.647-3.524 4.832 4.832 0 0 0 .067-.739c.001-.375.004.4.003-.004Zm.95 12.708a1.615 1.615 0 0 0 1.522-1.141 2.832 2.832 0 0 0 .063-.827 10.814 10.814 0 0 0-.088-1.87 4.879 4.879 0 0 0-3.605-3.823 6.4 6.4 0 0 0-1.55-.146h-3.2a6.112 6.112 0 0 0-1.587.164 4.881 4.881 0 0 0-3.546 3.867 11.75 11.75 0 0 0-.077 1.85 2.394 2.394 0 0 0 .086.854 1.687 1.687 0 0 0 .658.832 1.591 1.591 0 0 0 .84.241h10.483c.379.001-.403.005 0-.001Z'
		/>
		<path fill='none' d='M0 0h24v24H0z' data-name='Rect\xE1ngulo 85589' />
	</svg>
)
export default SvgComponent
